module.exports = __webpack_public_path__ + "static/media/YF52_3.ecbb5174.jpg";